<template>
  <div class="page-wrapper">
    <div style="width: 960px">
      <createForm
        :is-edit="true"
        @cancel="cancelCertificate"
        @confirm="confirmCertificate"
      />
    </div>
  </div>
</template>

<script>
import createForm from './component/createForm.vue'
import { utils } from "@/common/common.js";
import { request, api } from '@/common/request_course.js';
import { DEFAULT_CERTIFICATE_NAME } from "./util/constant.js";
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  inject: ['reload'],
  components: { createForm },
  methods: {
    // 取消
    cancelCertificate() {
      this.$router.go(-1)
    },
    // 获取证书
    getCertificateNumber() {
      return request({
        url: api.baseUrl + "/certificate/fzzht-member-certificate/getCertificateNumber",
        method: "get",
      })
    },
    async confirmCertificate(formData) {
      let form = formData.form
      let fzzhtMemberCertificates = formData.fzzhtMemberCertificates.map(item => {
        let r = {...item}
        delete r.showUrl
        if (r.type !== DEFAULT_CERTIFICATE_NAME) {
          delete r.number
        } 
        return r
      })
      let params = {}
      let fzzhtMemberInfo = {
        lastUpdateBy: this.adminId,
        businessLicenseNo: form.businessLicenseNumber,
        businessScope: form.businessScope,
        contactName: form.contactName,
        contactPhoneNumber: form.contactTel,
        desc: form.introduction,
        gender: form.sex,
        position: form.job,
        principalName: form.subjectName,
        principalType: form.subjectType,
        productLabel: form.goodsTag,
        responsiblePersonIdNumber: form.idNumber,
        source: form.resource,
        id: form.id,
        companyId: form.companyId,
        userId: form.userId,
        registerMobileNumber: form.registerMobileNumber
      }
      params = {
        fzzhtMemberInfo,
        fzzhtMemberCertificates,
      }
      console.log(params)
      // debugger
      request({
        url: api.baseUrl + "/certificate/fzzht-member-info/update",
        method: "post",
        data: params
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.$confirm('编辑成功', '提示', {
            confirmButtonText: '返回列表',
            cancelButtonText: '继续编辑',
            type: 'success',
            center: true,
            closeOnClickModal:false,
            showClose: false,
          }).then(() => {
            this.$router.go(-1);
          }).catch(() => {
            this.reload()
          })
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
  }
}
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
  box-sizing: border-box;
  min-height: calc(100vh - 74px);
}
</style>


// WEBPACK FOOTER //
// src/pages/certificate/edit.vue